import React, { Component } from "react";
import "./ToyotaLife.scss";

export default class Financing extends Component {

  toyotaLifeRedirect = () => {
    window.open('https://www.toyota.es/service-and-accessories/warranty-and-assistance/toyota-life','_blank')
  }


  render() {
    return (
      <div className="container-fluid container-without-padding general-life">
        <div className="rowLife row">
          <div className="left-life col-6 container-without-padding">
            <p className="section-particulares">
              Servicio exclusivo
            </p>
            <h2 className="h2-toyota-life">Toyota Relax</h2>
            <h5 className="section-garantia">
              Extensión de garantía GRATIS válida por 1 año o 15.000 kms o
              20.000 kms
            </h5>
            <div className="buttons-container btn-left">
              <button
                onClick={this.toyotaLifeRedirect}
                id="paddingLess"
                className="mm-button mm-rounded mm-out smallBtn"
              >
                Más información 
              </button>
            </div>
          </div>
          <div className="righ-life section-toyotaLife col-6 container-without-padding" />
        </div>
      </div>
    );
  }
}